import { Node } from 'tiptap'
import { setBlockType, textblockTypeInputRule, toggleBlockType } from 'tiptap-commands'

export default class SelectBox extends Node {

    get name() {
        return 'select_box'
    }

    get defaultOptions() {
        return {
        }
    }

    get schema() {
        return {
            attrs: {
                name: {
                    default: '',
                },
                label: {
                    default: '',
                },
                description: {
                    default: '',
                },
                rules: {
                    default: null,
                },
                selected: {
                    default: null,
                },
                options: {
                    default: '',
                },
                multiple: {
                    default: false,
                },
                classname: {
                    default: '',
                },
                style: {
                    default: '',
                },
            },
            group: 'block',
            defining: true,
            draggable: false,
            parseDOM: [{
                tag: 'tiptap-2milion-select',
                getAttrs: dom => ({
                    name: dom.getAttribute('name'),
                    label: dom.getAttribute('label'),
                    description: dom.getAttribute('description'),
                    rules: dom.getAttribute('rules'),
                    selected: dom.getAttribute('selected'),
                    options: dom.getAttribute('options'),
                    multiple: dom.getAttribute('multiple'),
                    classname: dom.getAttribute('classname'),
                    style: dom.getAttribute('style'),
                }),
            }],
            toDOM: node => ['tiptap-2milion-select', {
                name: node.attrs.name,
                label: node.attrs.label,
                description: node.attrs.description,
                rules: node.attrs.rules,
                selected: node.attrs.selected,
                options: node.attrs.options,
                multiple: node.attrs.multiple,
                classname: node.attrs.classname,
                style: node.attrs.style,
            }],
        }
    }

    commands({ type }) {
        return attrs => (state, dispatch) => {
            const { selection } = state;
            const position = selection.$cursor
                ? selection.$cursor.pos
                : selection.$to.pos;
            const node = type.create(attrs);
            const transaction = state.tr.insert(position, node);
            dispatch(transaction);
        };
    }

    get view() {
        return {
            props: ['node', 'updateAttrs', 'view'],
            computed: {
                name: {
                    get() {
                        return this.node.attrs.name
                    },
                    set(name) {
                        this.updateAttrs({
                            name,
                        })
                    },
                },
                label: {
                    get() {
                        return this.node.attrs.label
                    },
                    set(label) {
                        this.updateAttrs({
                            label,
                        })
                    },
                },
                description: {
                    get() {
                        return this.node.attrs.description
                    },
                    set(description) {
                        this.updateAttrs({
                            description,
                        })
                    },
                },
                rules: {
                    get() {
                        return typeof this.node.attrs.rules === 'string' ? this.node.attrs.rules.replace(/^\|+|\|+$/g, '').split('|') : this.node.attrs.rules
                    },
                    set(rules) {
                        this.updateAttrs({
                            rules: Array.isArray(rules) ? rules.join('|') : rules,
                        })
                    },
                },
                rules_text: {
                    get() {
                        return Array.isArray(this.node.attrs.rules) ? this.node.attrs.rules.join('|') : this.node.attrs.rules
                    },
                    set(rules_text) {
                        this.updateAttrs({
                            rules: rules_text
                        })
                    },
                },
                selected: {
                    get() {
                        if (!this.node.attrs.multiple) {
                            return this.node.attrs.selected
                        } else {
                            if (Array.isArray(this.node.attrs.selected)) {
                                return this.node.attrs.selected
                            }
                            if (this.node.attrs.selected === null) {
                                return []
                            }
                            if (typeof this.node.attrs.selected === 'string') {
                                return this.node.attrs.selected.replace(/^\|+|\|+$/g, '').split('|')
                            }
                        }
                    },
                    set(selected) {
                        this.updateAttrs({
                            selected: Array.isArray(selected) ? selected.join('|') : selected,
                        })
                    },
                },
                options: {
                    get() {
                        return this.node.attrs.options
                    },
                    set(options) {
                        this.updateAttrs({
                            options,
                        })
                    },
                },
                options_array: {
                    get() {
//                        return this.node.attrs.options.split(/\r\n|\n/)
                        let options = this.node.attrs.options.split(/\r\n|\n/)
                        return options.map((e) => {
                            e = e.split('|')
                            return {
                                text: e[0],
                                value: e[0],
                            }
//                            let text = e[0],
//                                value = e[0],
//                                count = 70,
//                                maximum = null
//                            if (e.length > 1) {
//                                maximum = Number.parseInt(e[1]) || null
//                            }
//                            return {
//                                text: maximum ? text + `(${count}/${maximum})` : text,
//                                value: value,
//                                count: count,
//                                maximum: maximum,
////                                disabled: maximum && (count >= maximum),
//                            }
                        })
                    },
                },
                multiple: {
                    get() {
                        return this.node.attrs.multiple ? true : false
                    },
                    set(multiple) {
                        this.updateAttrs({
                            multiple: multiple ? 'multiple' : '',
                        })
                    },
                },
                classname: {
                    get() {
                        return this.node.attrs.classname
                    },
                    set(classname) {
                        this.updateAttrs({
                            classname,
                        })
                    },
                },
                style: {
                    get() {
                        return this.node.attrs.style
                    },
                    set(style) {
                        this.updateAttrs({
                            style,
                        })
                    },
                },
            },
            methods: {
                hasRule(rule) {
                    if (!Array.isArray(this.rules)) {
                        return false
                    }
                    return this.rules.indexOf(rule) >= 0
                },
            },
            template: `
<div :style="style" :class="(view.editable ? 'p-3 mb-4 bg-light' : '') + classname">

<p class="label mb-0" v-if="label"><strong>{{ label }}</strong></p><p class="mb-0" v-if="description">{{ description }}</p><b-form-select v-model="selected" :options="options_array" :name="name + (multiple ? '[]' : '')" :multiple="multiple" class="mb-4" />

    <b-form-group
        label-cols-sm="2"
        label="設定"
        label-size="sm"
        @submit.stop.prevent
        v-if="view.editable"
        >
        <b-row>
            <b-col>
                <small>フィールド</small>
                <b-form-input
                    v-model="name"
                    size="sm"
                    type="text"
                    @cut.stop
                    @copy.stop
                    @paste.stop
                    />
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <small>ラベル</small>
                <b-form-input
                    v-model="label"
                    size="sm"
                    type="text"
                    @cut.stop
                    @copy.stop
                    @paste.stop
                    />
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <small>説明</small>
                <b-form-input
                    v-model="description"
                    size="sm"
                    type="text"
                    @cut.stop
                    @copy.stop
                    @paste.stop
                    />
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <small>入力規則</small>
                <b-form-checkbox-group
                    v-model="rules"
                    size="sm"
                    >
                    <b-form-checkbox value="required">必須</b-form-checkbox>
                </b-form-checkbox-group>
                <b-form-input
                    v-model="rules_text"
                    size="sm"
                    type="text"
                    style="margin-top: -1.5em;"
                    @cut.stop
                    @copy.stop
                    @paste.stop
                    />
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <small>選択肢</small>
                <b-form-textarea
                    v-model="options"
                    size="sm"
                    rows="3"
                    max-rows="6"
                    @cut.stop
                    @copy.stop
                    @paste.stop
                    />
                <small>選択</small>
                <b-form-select
                    v-model="multiple"
                    size="sm"
                    >
                    <b-form-select-option :value="false">単数</b-form-select-option>
                    <b-form-select-option :value="true">複数</b-form-select-option>
                </b-form-select>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <small>classname</small>
                <b-form-input
                    v-model="classname"
                    size="sm"
                    type="text"
                    @cut.stop
                    @copy.stop
                    @paste.stop
                    />
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <small>style</small>
                <b-form-input
                    v-model="style"
                    size="sm"
                    type="text"
                    @cut.stop
                    @copy.stop
                    @paste.stop
                    />
            </b-col>
        </b-row>
    </b-form-group>
</div>
                `,
        }
    }

}
